import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import useReveal from '../hooks/useReveal';
import { PROCESS_ICONS, IMAGES } from '../mock/mock';
import { PageHero } from './Services';

const RnD = () => {
  const { t, lang } = useLang();
  useReveal(lang);
  const steps = t('rnd.steps');

  return (
    <div>
      <PageHero kicker={t('rnd.kicker')} title={t('rnd.title')} subtitle={t('rnd.subtitle')} image={IMAGES.lab} />

      {/* TIMELINE */}
      <section className="py-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="relative">
            <div className="absolute left-[27px] rtl:left-auto rtl:right-[27px] top-2 bottom-2 w-px bg-gold-soft" />
            <div className="space-y-12">
              {steps.map((s, i) => {
                const Icon = Icons[PROCESS_ICONS[i]] || Icons.Circle;
                return (
                  <div key={i} className="reveal relative flex gap-8 items-start">
                    <div className="shrink-0 w-14 h-14 rounded-full bg-espresso text-gold-light flex items-center justify-center z-10 shadow-lg"><Icon className="w-6 h-6" /></div>
                    <div className="pt-1">
                      <span className="text-[0.68rem] tracking-[0.25em] uppercase text-gold">{t('home.productsKicker')} · {String(i + 1).padStart(2, '0')}</span>
                      <h3 className="font-serif text-2xl md:text-3xl text-espresso mt-1">{s.title}</h3>
                      <p className="mt-2 text-mocha leading-relaxed max-w-xl">{s.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* CLOSING */}
      <section className="relative py-28 bg-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
          <div className="reveal img-zoom aspect-square shadow-[0_30px_70px_-30px_rgba(43,36,32,0.35)]">
            <img src={IMAGES.bottlesNeutral} alt="" className="w-full h-full object-cover" />
          </div>
          <div className="reveal">
            <h2 className="font-serif text-4xl md:text-5xl text-espresso leading-tight italic">{t('rnd.closingTitle')}</h2>
            <p className="mt-6 text-mocha leading-relaxed text-lg">{t('rnd.closingText')}</p>
            <Link to="/contact" className="group mt-8 inline-flex items-center gap-3 px-9 py-4 bg-espresso text-ivory text-xs tracking-[0.2em] uppercase hover:bg-gold transition-colors">
              {t('home.ctaButton')}<ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform rtl:rotate-180" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RnD;
